import React from 'react';
import { Button } from '../Button';
export function PhoneButton() {
  return <div className="hidden md:block" data-id="element-120">
      <Button variant="primary" size="sm" className="font-bold" href="tel:231-266-0606" data-id="element-121">
        231-266-0606
      </Button>
    </div>;
}